export const API_BASE_URL = "https://api.stackora.iosx.in/api/v1/";
export const SOCKET_URL = "https://api.stackora.iosx.in";
// export const API_BASE_URL = "http://192.168.0.131:3666/api/v1";
// export const SOCKET_URL = "http://192.168.0.131:3666";


// export const API_BASE_URL = "http://127.0.0.1:4748/api/v1";
// export const SOCKET_URL = "https://127.0.0.1:4748";